import { render } from "./fontSizePopBnt.vue?vue&type=template&id=3b0eca70"
import script from "./fontSizePopBnt.vue?vue&type=script&lang=js"
export * from "./fontSizePopBnt.vue?vue&type=script&lang=js"

import "./fontSizePopBnt.vue?vue&type=style&index=0&id=3b0eca70&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__